<div class="loadingImg">
  <i class="fa fa-spinner fa-spin fa-5x"></i>
</div>
